module.exports = __webpack_public_path__ + "static/img/icon-4.bc52488a.png";